import React from "react";

const PLACEHOLDER_COLOR = "#e5e7eb";

type BarProps = {
  width: number | string;
  height: number;
  borderRadius?: number;
};

const SkeletonBar = ({ width, height, borderRadius = 4 }: BarProps) => (
  <div
    className="animate-pulse"
    style={{ width, height, backgroundColor: PLACEHOLDER_COLOR, borderRadius }}
  />
);

const SkeletonCard = () => (
  <div
    style={{
      padding: 16,
      backgroundColor: "white",
      marginBottom: 8,
      width: "100%",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
        marginBottom: 12,
      }}
    >
      <div
        className="animate-pulse"
        style={{
          width: 40,
          height: 40,
          borderRadius: 20,
          backgroundColor: PLACEHOLDER_COLOR,
          flexShrink: 0,
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          flex: 1,
        }}
      >
        <SkeletonBar width={140} height={12} />
        <SkeletonBar width={90} height={10} />
      </div>
    </div>
    <div
      className="animate-pulse"
      style={{
        width: "100%",
        aspectRatio: "4 / 3",
        backgroundColor: PLACEHOLDER_COLOR,
        borderRadius: 8,
        marginBottom: 12,
      }}
    />
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <SkeletonBar width="92%" height={12} />
      <SkeletonBar width="70%" height={12} />
    </div>
  </div>
);

type FeedSkeletonProps = {
  /** Number of placeholder cards. Defaults to 3 — enough to fill the typical viewport without dominating it. */
  count?: number;
};

export function FeedSkeleton({ count = 3 }: FeedSkeletonProps) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 680,
        alignSelf: "center",
        margin: "0 auto",
      }}
      aria-busy="true"
      aria-label="Loading feed"
    >
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
